import Step1 from './step1.form';
import Step2 from './step2.form';
import Result from './result.form';

export default {
    Step1,
    Step2,
    Result
}